<form>
    <EmptyHeader />

    <section class="login-section login-eportfolio">
        <div class="login-box">
            <div class="login-item">
                <span>
                    {headingTitle}
                </span>
                <span class="login-eportfolio-title">
                    {headingText}
                </span>
            </div>
            <div class="login-item">
                <TextField
                    id="password"
                    bind:this={password}
                    type="password"
                    required
                    bind:value={unsavedPassword}
                    placeholder={terms.password}
                    label={terms.password}
                    disabled={loginInProgress}
                    errorMessage={loginErrorMessage}
                    hasError={passwordHasErrors}
                    labelHidden
                    minlength="1"
                    maxlength="20" />
            </div>
            <div>
                <Button type="primary" text={terms.logIn} htmlType="submit" on:click={login} disabled={loginInProgress} />
            </div>
        </div>
    </section>
</form>

<script>
    import TextField from '@itslearning/prometheus/assets/inputs/TextField/v1/TextField.svelte';
    import Button from '@itslearning/prometheus/assets/inputs/Button/v1/Button.svelte';
    import EmptyHeader from '@itslearning/prometheus/assets/nodes/EmptyHeader/v1/EmptyHeader.svelte';
    import { post } from '@itslearning/atlas/network/fetch';

    export let loginUrl = '';
    export let headingText = '';
    export let headingTitle = '';
    export let terms = {};
    export let loginInProgress = false;
    export let loginErrorMessage = '';
    export let unsavedPassword = '';
    export let successUrl = '';

    $: passwordHasErrors = loginErrorMessage.length > 0;

    let password;

    function login() {
        if (loginInProgress) {
            return;
        }

        if (!unsavedPassword || unsavedPassword.length === 0) {
            loginErrorMessage = terms.pleaseEnterPassword;

            return;
        }

        loginInProgress = true;
        loginErrorMessage = '';

        return post(loginUrl, {
            Password: unsavedPassword,
        })
            .then((data) => {
                if (data.Success) {
                    window.location = successUrl;
                    loginErrorMessage = '';
                } else {
                    loginErrorMessage = data.ErrorMessage;
                }
            })
            .catch((e) => {
                console.error(e);
                loginErrorMessage = terms.unknownError;
            })
            .finally(() => {
                loginInProgress = false;
            });
    }
</script>
